<template>
   <div class="file-upload-component">
      <div
         class="upload-box rounded p-4 text-center mb-3"
         @dragover.prevent
         @drop.prevent="handleDrop"
      >
         <div class="mb-3">
            <img
               src="@/assets/img/upload-file.png"
               style="height: 25px; width: 30px"
               alt="upload"
            />
            <div class="font-weight-bold file-upload-label">Drag and drop files here</div>
            <div class="file-upload-label text-muted mb-1">or</div>
            <button
               :disabled="disabled"
               class="btn btn-primary light-button file-upload-label btn-color"
               @click="triggerFileInput"
            >
               Select Files
            </button>
            <input
               type="file"
               :multiple="multiple"
               ref="fileInput"
               class="d-none"
               :disabled="disabled"
               @change="handleFileSelect"
               :accept="acceptFileTypes"
            />
         </div>
         <small class="text-muted mt-4 file-upload-label">{{ limits }}</small>
      </div>

      <!-- Uploaded file preview -->
      <div class="file-preview-container" v-if="files.length > 0">
         <div
            v-for="(file, index) in files"
            :key="fileKey(file, index)"
            class="
               file-preview-item
               bg-light
               p-3
               rounded
               d-flex
               justify-content-between
               align-items-center
            "
         >
            <div class="d-flex align-items-center justify-content-start">
               <img src="@/assets/img/file.png" style="height: 30px; width: 25px" alt="file" />
               <div>
                  <strong class="ml-2 file-name">{{ file.name }}</strong>
                  <div class="text-muted ml-2" style="font-size: 11px">
                     File size: {{ formatSize(file.size) }}
                  </div>
               </div>
            </div>
            <div v-if="canDeleteFiles" class="right d-flex align-items-center">
               <button
                  type="button"
                  class="icon-btn trash-icon-btn"
                  aria-label="Delete"
                  @click="removeFile(index)"
               >
                  <b-icon style="width: 1rem; height: 1rem" icon="trash" />
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'FileUploadComponent',
   props: {
      currentFiles: {
         type: Array,
         default: () => [],
      },
      disabled: {
         type: Boolean,
         default: false,
      },
      multiple: {
         type: Boolean,
         default: false,
      },
      limits: {
         type: String,
         default: 'XLSX or CSV | Limit 10MB',
      },
      canDeleteFiles: {
         type: Boolean,
         default: true,
      },
      acceptFileTypes: {
         type: String,
         default: '*.*',
      },
   },
   data() {
      return {
         files: [],
      };
   },
   methods: {
      fileKey(file, index) {
         if (file?.existing && file.id != null) {
            return `existing-${file.id}`;
         }
         return `${file?.name}-${file?.size}-${file?.lastModified ?? index}`;
      },
      triggerFileInput() {
         this.$refs.fileInput.click();
      },
      handleFileSelect(event) {
         const selected = this.multiple ? event.target.files : event.target.files[0];
         if (selected) {
            this.files = this.multiple ? [...selected] : [selected];
            this.$emit('files-selected', selected);
         }
      },
      handleDrop(event) {
         if (this.disabled) {
            return;
         }
         const dropped = this.multiple ? event.dataTransfer.files : event.dataTransfer.files[0];
         if (dropped) {
            this.files = this.multiple ? [...dropped] : [dropped];
            this.$emit('files-selected', dropped);
         }
      },
      removeFile(index) {
         const fileToBeDeleted = this.files[index];
         this.$refs.fileInput.value = null;
         this.$emit('file-delete', fileToBeDeleted);
      },
      formatSize(bytes) {
         const kb = bytes / 1024;
         return kb < 1024 ? `${kb.toFixed(1)}kB` : `${(kb / 1024).toFixed(1)}MB`;
      },
   },

   async created() {
      if (this.currentFiles) {
         this.files = this.currentFiles;
      }
   },

   watch: {
      currentFiles(newVal) {
         this.files = newVal;
      },
   },
};
</script>

<style scoped lang="scss">
.upload-box {
   border: 2px dashed #ccc;
}
.upload-box.dragover {
   background-color: #e9f5ff;
}
.file-upload-label {
   font-size: 13px;
}

.file-name {
   font-size: 13px;
}

.icon-btn {
   border: none;
   background: transparent;
   color: #98a2b3;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   transition: background 0.12s ease, color 0.12s ease;
   cursor: pointer;
}

.icon-btn:hover {
   background: #eef2f7;
   color: #667085;
}

.trash-icon-btn:hover {
   color: $danger;
}
.file-preview-container .file-preview-item {
   margin-bottom: 10px;
}
</style>
